import { EnvironmentKey, getAvailableEnvironments } from '@choco-admin/utils';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@heroui/react';
import React from 'react';

import { EnvironmentItem } from './EnvironmentItem';

interface EnvironmentModalProps {
  currentEnvironment: EnvironmentKey;
  onEnvironmentSelect: (env: EnvironmentKey) => void;
  onClose: () => void;
}

export const EnvironmentModal: React.FC<EnvironmentModalProps> = ({
  currentEnvironment,
  onEnvironmentSelect,
  onClose,
}) => {
  const availableEnvironments = getAvailableEnvironments();

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      backdrop="blur"
      classNames={{
        backdrop: 'bg-black/50',
        base: 'border-none',
        body: 'p-0',
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold">Select Environment</h2>
        </ModalHeader>
        <ModalBody>
          <div className="max-h-96 overflow-y-auto py-2">
            {availableEnvironments.map((environment) => (
              <EnvironmentItem
                key={environment}
                environment={environment}
                isSelected={environment === currentEnvironment}
                onSelect={onEnvironmentSelect}
              />
            ))}
          </div>
        </ModalBody>
        <ModalFooter className="bg-default-50">
          <p className="text-sm text-default-500 text-center w-full">
            Changes will take effect after logout and reload
          </p>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
